import { useEffect } from "react";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Worlds } from "@/components/Worlds";
import { Flagship } from "@/components/Flagship";
import { CreditsSection } from "@/components/CreditsSection";
import { Pricing } from "@/components/Pricing";
import { AppSection } from "@/components/AppSection";
import { Trust } from "@/components/Trust";
import { Founder } from "@/components/Founder";
import { Contact } from "@/components/Contact";

export default function HomePage() {
  useEffect(() => {
    document.title = "ORIVA AI — One AI. Three powerful worlds.";
  }, []);

  return (
    <main>
      <Hero />
      <MarqueeStrip />
      <Worlds />
      <Flagship />
      <CreditsSection />
      <Pricing />
      <AppSection />
      <Trust />
      <Founder />
      <Contact />
    </main>
  );
}
